import type { Product } from './types'

/* Live product registry. Populated by InventoryProvider from the GraphQL API.
   Pages/components look products up synchronously via these helpers, while the
   reactive copy is also exposed through useInventory().products. */
export let products: Product[] = []
export let productCategories: string[] = []

export function setProducts(next: Product[]): void {
  products = next
  productCategories = Array.from(
    new Set(next.map((p) => p.category).filter(Boolean)),
  ).sort()
}

export const productById = (id: string) => products.find((p) => p.id === id)

/** Products a new purchase or sales order may name: active only. xl-ops refuses an inactive product on a PO line
    and at every stock-attachment point (ISOT-40 G1), so offering one would only produce a server error. */
export const orderableProducts = (list: Product[] = products): Product[] => list.filter((p) => p.active !== false)
export const productBySku = (sku: string) => products.find((p) => p.sku === sku)
